import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import { Autocomplete, Button } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import "./reminder.scss";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { addNewReminder, editReminder, fetchFuelById, fetchReminderById, fetchVehicle } from "../../store/slices/thunk";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/esm/Spinner";


const Addreminder = () => {
  const [addReminder, setAddReminder] = useState({
    vehicle: {
      vehicleId: "",
      vehicleName: ""
    },
    date: 0,
    message: "",
    _id: '',
  });

  const { id } = useParams<any>();
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const dispatch: any = useDispatch();
  const [getAllVehicle, setAllVehicle] = useState([]);
  const [searchVehicle, setSearchVehicle] = React.useState("");
  const [totalCount, setTotalCount] = useState(0);
  const DEBOUNCE_DELAY = 500;
  const ITEMS_PER_PAGE = 10;
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsEdit(true);
        const response: any = await dispatch(fetchReminderById(id));

        const {
          vehicle,
          date,
          message,
          _id
        } = response.data;

        setAddReminder({
          vehicle: {
            vehicleId: vehicle?.vehicleId || "",
            vehicleName: vehicle?.vehicleName || ""
          },
          date: date || "",
          message: message || "",
          _id: _id || ""
        });

        console.log("Fetched Fuel Record:", response.data);
      } else {
        setIsEdit(false);
        setAddReminder({
          vehicle: {
            vehicleId: "",
            vehicleName: ""
          },
          date: 0,
          message: "",
          _id: ""
        });
      }
    };

    fetchData();
  }, [id, navigate, dispatch]);


  useEffect(() => {
    const handler = setTimeout(async () => {
      const response = await dispatch(fetchVehicle(1, 10, searchVehicle));
      if (response && response?.data && response?.data?.data && response?.data?.data?.length && response?.isSuccess) {
        setAllVehicle(response?.data?.data);
        setTotalCount(response?.data?.totalCount);
      } else {
        setAllVehicle([]);
        setTotalCount(0);
      }
    }, DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    }
  }, [searchVehicle, dispatch]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    console.log("Sending:", addReminder);
    setLoading(true);

    try {
      const {
        vehicle,
        date,
        message
      } = addReminder;

      if (
        vehicle.vehicleId === "" ||
        vehicle.vehicleName === "" ||
        date === 0 ||
        message.trim() === ""
      ) {
        toast.error("Fill all required fields!");
        return;
      }



      if (isEdit) {
        const res: any = await dispatch(editReminder(addReminder));
        if (res.data && res.isSuccess) {
          console.log("Success:", res);
          toast.success("Reminder Updated!");
          navigate("/reminder-list");
        } else {
          toast.error("Reminder Not Updated!");
        }
      } else {
        const res: any = await dispatch(addNewReminder(addReminder));
        if (res.data && res.isSuccess) {
          console.log("Success:", res);
          toast.success("Reminder Added!");
          navigate("/reminder-list");
        } else {
          toast.error("Reminder Not Added!");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };


  const handleChangeForVehicle = (e: any) => {
    const { value } = e.target;
    if (!value) {
      // Jab user ne selection clear kar diya
      setAddReminder({
        ...addReminder,
        vehicle: {
          vehicleId: "",
          vehicleName: "",
        },
      });
      return;
    }

    const selectedVehicle: any = getAllVehicle.find((vehicle: any) => vehicle._id === value);

    if (selectedVehicle) {
      setAddReminder({
        ...addReminder,
        vehicle: {
          vehicleId: selectedVehicle._id,
          vehicleName: selectedVehicle.vehicleName,
        },
      });
    }
  };
 const navigateToReminderList = () => {
    navigate("/reminder-list");
  };
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setAddReminder((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  return (
    <div>
      <ToastContainer />
      <div className="boDy">
        <div className="head d-flex justify-content-lg-between justify-content-start flex-column flex-lg-row flex-wrap">
          <div className="d-flex flex-column">
                                    <h2 className="fw-bold fs-4" style={{ color: "#1F2937" }}>{isEdit ? "Edit Reminder" : "Add New Reminder"}</h2>

            <p style={{ color: "#4B5563" }}>Set up maintenance and document reminders</p>
          </div>
          <button
            type="button"
            onClick={navigateToReminderList}
            className="btn rounded-2"
            style={{ backgroundColor: "transparent",width:"fit-content" }}
          >
            <KeyboardBackspaceIcon />
            <span style={{marginLeft:"10px"}}>Back To List</span>
          </button>
        </div>
        <div className="boX">
          <div className="container mt-3">
            <div className="row">
              <div className="col-md-6 mt-3">
                <h6 className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Vehicle*</h6>
                <Box >
                  <Autocomplete
                    options={getAllVehicle}
                    getOptionLabel={(option: any) => option.vehicleName}
                    value={
                      getAllVehicle.find(
                        (v: any) => v._id === addReminder.vehicle?.vehicleId
                      ) || null
                    }
                    onInputChange={(event, newInputValue) => {
                      setSearchVehicle(newInputValue);
                    }}
                    onChange={(event, newValue: any) => {
                      if (newValue) {
                        handleChangeForVehicle({
                          target: { value: newValue._id },
                        });
                      } else {

                        handleChangeForVehicle({
                          target: { value: "" },
                        });
                      }
                    }}
                    clearOnEscape
                    ListboxProps={{
                      sx: {
                        backgroundColor: "#fff",
                        color: "#000",
                        '& .MuiAutocomplete-option': {
                          color: '#000',
                        }
                      },
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Search or Select Vehicle" />
                    )}
                  />
                </Box>
              </div>
              <div className="col-md-6 mt-3">
                <h6 className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Date*</h6>
                <TextField
                  id="outlined-basic"
                  placeholder="add reminder date"
                  variant="outlined"
                  type="date"
                  value={
                    addReminder.date
                      ? new Date(addReminder.date).toISOString().split("T")[0]
                      : ""
                  }
                  onChange={(e) =>
                    setAddReminder({
                      ...addReminder,
                      date: new Date(e.target.value).getTime(),
                    })
                  }
                  sx={{ height: "48px", width: "100%" }}
                  // fullWidth sx={{
                  //   '& .MuiInputBase-input': {
                  //     padding: '12px',
                  //   },
                  // }}
                />{" "}
              </div>
              <div className="col-md-12 mt-3">
                <div className="gps">
                  <h6 className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Message*</h6>
                  <TextField
                    type="text"
                    placeholder="messege"
                    name="message"
                    value={addReminder.message}
                    onChange={handleChange}
                    multiline
                    rows={2}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <div className="container">
            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <h6>Date*</h6>
                <TextField
                  id="outlined-basic"
                  placeholder="add reminder date"
                  variant="outlined"
                  type="date"
                  value={
                    addReminder.date
                      ? new Date(addReminder.date).toISOString().split("T")[0]
                      : ""
                  }
                  onChange={(e) =>
                    setAddReminder({
                      ...addReminder,
                      date: new Date(e.target.value).getTime(),
                    })
                  }
                  sx={{ height: "48px", width: "100%" }}
                  // fullWidth sx={{
                  //   '& .MuiInputBase-input': {
                  //     padding: '12px',
                  //   },
                  // }}
                />{" "}
              </div>
              <div className="col-md-3">
              </div>
            </div>
          </div> */}
          {/* <div className="container">
            <div className="row">
              <div className="col-md-3 "></div>
              <div className="col-md-6">
                <div className="gps">
                  <h6>Message*</h6>
                  <TextField
                    type="text"
                    placeholder="messege"
                    name="message"
                    value={addReminder.message}
                    onChange={handleChange}
                    multiline
                    rows={2}
                    fullWidth
                  />
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div> */}  
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="aDDD">
                  <Button  onClick={handleSubmit} disabled={loading} style={{ textTransform: "none",fontWeight:"600",width:"auto" }}>
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        {isEdit ? "Edit..." : "Add..."}
                      </>
                    ) : (
                      isEdit ? "Edit Inventory " : "Add Inventory"
                    )}
                  </Button>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addreminder;
